import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { catchError, Observable, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';
import { SKIP_AUTH_INTERCEPTOR, TEST_CONST } from '../constants/constants';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { StateManagementService } from '../services/state-management.service';

export class AuthInterceptorService implements HttpInterceptor {

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const router: Router = inject(Router);
  const localEnvironment = window.location.href.indexOf('.com') === -1;
  const serverlessApi = this.isServerlessApi(req.url);
  const stateManagerService = inject(StateManagementService);

  const isS3Request = req.url.includes('amazonaws.com');

  if (req.headers.has('X-Skip-AuthInterceptor') || req.context.get(SKIP_AUTH_INTERCEPTOR)) {
    const headers = req.headers.delete('X-Skip-AuthInterceptor');
    req = req.clone({ headers });
  } else if (!isS3Request) {
    const idtoken = sessionStorage.getItem(TEST_CONST.auth_token);
    req = req.clone({
      headers: req.headers.append('Authorization', `${idtoken}`),
    });
  }

  if (localEnvironment && serverlessApi) {
    req = this.applyCorsPolicy(req);
  }

  return next.handle(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        const currentUrl = router.url;
        sessionStorage.removeItem(TEST_CONST.auth_token);
        if (currentUrl.startsWith('/test')) {
          stateManagerService.isSubmitTestRouteAllowed = true;
          router.navigate(['/submit-test']);
        } else {
          router.navigate(['/']);
        }
      }
      return throwError(() => error);
    })
  );
}

  private isServerlessApi(url: string): boolean {
    if (!url) {
      return false;
    }
    if (/api./.test(url)) {
      return true;
    }
    return false;
  }

  private applyCorsPolicy(req: HttpRequest<any>): HttpRequest<any> {
    if (/api/.test(req.url)) {
      return req.clone({
        url: req.url.replace(environment.BASE_URL, ''),
      });
    }
    return req;
  }
}
